import React from 'react'
import { IconFolder, IconTrash } from '@tabler/icons-react'
import Typography from '../../atoms/Typography'
import TooltipWrapper from '../../atoms/TooltipWrapper'
import { GradientBorderButton } from '../../atoms/buttons/GradientBorderButton'

interface DataRoomActionPanelProps {
  selectedCount: number
  isDeleting: boolean
  availableFolderCount: number
  onDelete: () => void
  onClear: () => void
  onMoveToFolder: () => void
}

const Divider = () => <div className="h-8 w-px shrink-0 bg-gray-500" />

export const DataRoomActionPanel: React.FC<DataRoomActionPanelProps> = ({
  selectedCount,
  isDeleting,
  availableFolderCount,
  onDelete,
  onClear,
  onMoveToFolder,
}) => (
  <div className="pointer-events-none fixed inset-x-0 bottom-[calc(5vh+2rem)] z-[60] flex justify-center">
    <div
      className="pointer-events-auto flex items-center gap-4 rounded-xl border border-gray-500 bg-gray-900 px-5 py-3 shadow-lg"
      onPointerDown={(e) => e.stopPropagation()}
    >
      <Typography variant="sm" className="whitespace-nowrap text-gray-200">
        {selectedCount} {selectedCount === 1 ? 'File' : 'Files'} Selected
      </Typography>

      <Divider />

      {availableFolderCount >= 1 ? (
        <GradientBorderButton gradientSize="sm" textSize="sm" disabled={isDeleting} onClick={onMoveToFolder}>
          <IconFolder className="h-4 w-4" />
          Move to Folder
        </GradientBorderButton>
      ) : (
        <TooltipWrapper content="No other folders to move files to." side="top" contentClassName="z-[70]">
          <span>
            <GradientBorderButton gradientSize="sm" textSize="sm" disabled>
              <IconFolder className="h-4 w-4" />
              Move to Folder
            </GradientBorderButton>
          </span>
        </TooltipWrapper>
      )}

      <button
        onClick={onDelete}
        disabled={isDeleting}
        className="flex items-center gap-2 rounded-full bg-red-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-red-700 disabled:opacity-50"
      >
        <IconTrash className="h-4 w-4" />
        Delete
      </button>

      <Divider />

      <button
        onClick={onClear}
        disabled={isDeleting}
        className="text-sm text-light-green-500 transition-colors hover:text-light-green-400 disabled:opacity-50"
      >
        Close
      </button>
    </div>
  </div>
)
